/*!
 * devextreme-angular
 * Version: 16.2.5
 * Build date: Tue Feb 28 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var nested_option_1 = require('../../core/nested-option');
var nested_option_2 = require('../../core/nested-option');
var DxoPointComponent = (function (_super) {
    __extends(DxoPointComponent, _super);
    function DxoPointComponent(parentOptionHost, optionHost) {
        _super.call(this);
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }
    Object.defineProperty(DxoPointComponent.prototype, "border", {
        get: function () {
            return this._getOption('border');
        },
        set: function (value) {
            this._setOption('border', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "color", {
        get: function () {
            return this._getOption('color');
        },
        set: function (value) {
            this._setOption('color', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "hoverMode", {
        get: function () {
            return this._getOption('hoverMode');
        },
        set: function (value) {
            this._setOption('hoverMode', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "hoverStyle", {
        get: function () {
            return this._getOption('hoverStyle');
        },
        set: function (value) {
            this._setOption('hoverStyle', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "image", {
        get: function () {
            return this._getOption('image');
        },
        set: function (value) {
            this._setOption('image', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "selectionMode", {
        get: function () {
            return this._getOption('selectionMode');
        },
        set: function (value) {
            this._setOption('selectionMode', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "selectionStyle", {
        get: function () {
            return this._getOption('selectionStyle');
        },
        set: function (value) {
            this._setOption('selectionStyle', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "size", {
        get: function () {
            return this._getOption('size');
        },
        set: function (value) {
            this._setOption('size', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "symbol", {
        get: function () {
            return this._getOption('symbol');
        },
        set: function (value) {
            this._setOption('symbol', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "visible", {
        get: function () {
            return this._getOption('visible');
        },
        set: function (value) {
            this._setOption('visible', value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DxoPointComponent.prototype, "_optionPath", {
        get: function () {
            return 'point';
        },
        enumerable: true,
        configurable: true
    });
    DxoPointComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'dxo-point',
                    template: '',
                    styles: [''],
                    providers: [nested_option_1.NestedOptionHost]
                },] },
    ];
    DxoPointComponent.ctorParameters = function () { return [
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.SkipSelf }, { type: core_1.Host },] },
        { type: nested_option_1.NestedOptionHost, decorators: [{ type: core_1.Host },] },
    ]; };
    DxoPointComponent.propDecorators = {
        'border': [{ type: core_1.Input },],
        'color': [{ type: core_1.Input },],
        'hoverMode': [{ type: core_1.Input },],
        'hoverStyle': [{ type: core_1.Input },],
        'image': [{ type: core_1.Input },],
        'selectionMode': [{ type: core_1.Input },],
        'selectionStyle': [{ type: core_1.Input },],
        'size': [{ type: core_1.Input },],
        'symbol': [{ type: core_1.Input },],
        'visible': [{ type: core_1.Input },],
    };
    return DxoPointComponent;
}(nested_option_2.NestedOption));
exports.DxoPointComponent = DxoPointComponent;
var DxoPointModule = (function () {
    function DxoPointModule() {
    }
    DxoPointModule.decorators = [
        { type: core_1.NgModule, args: [{
                    declarations: [
                        DxoPointComponent
                    ],
                    exports: [
                        DxoPointComponent
                    ],
                },] },
    ];
    DxoPointModule.ctorParameters = function () { return []; };
    return DxoPointModule;
}());
exports.DxoPointModule = DxoPointModule;
//# sourceMappingURL=point.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/devextreme-angular/ui/nested/point.js
// module id = ../../../../devextreme-angular/ui/nested/point.js
// module chunks = 3